import { useQuery } from '@tanstack/react-query';
import { getAuthorizationServerInfo } from '../lib/oauth4webapi/getAuthorizationServerInfo';
export const useAuthorizationServerInfoQuery = (issuerUrl) => {
    return useQuery({
        queryFn: () => {
            return issuerUrl && getAuthorizationServerInfo(issuerUrl);
        },
        queryKey: ['authorizationServerInfo', issuerUrl?.toString()],
        enabled: !!issuerUrl,
    });
};
